import { ComponentView, ObservableArray } from "binder";
import { LineItemViewModel } from "./lineItem/lineItem-viewModel";
import { TreeViewModel } from "./tree-viewModel"

export class TreeView extends ComponentView<TreeViewModel>{
    GetViewUniqueId(): string {
        return "V-874DAA54-86DB-4A4B-A253-37DB5E3EC7A4"
    }
    loadHtml(): string {
        let element = require('./tree.html').default;
        let style = require('./tree.less');
        return element;
    }
    constructor() {
       super();
    }
    append(...nodes: (Node | string)[]): void{
        nodes.forEach(node=>{
            if(node instanceof HTMLElement && node.classList.contains("template")){
                this.template = super.removeAsTemplate(node);
            }else{
                this.firstlevelElement.append(node);
            }
        })
    }
    public set template(v: Node) { this._template = v; } public get template(): Node { return this._template;} private _template: Node;

    public set internalItems(v: ObservableArray<LineItemViewModel>) { this._internalItems = v; } public get internalItems(): ObservableArray<LineItemViewModel> { return this._internalItems;} private _internalItems: ObservableArray<LineItemViewModel>;
    public set searchText(v: string) { this._searchText = v; } public get searchText(): string { return this._searchText;} private _searchText: string;
    public set allowfiltering(v: boolean) { this._allowFiltering = v; } public get allowfiltering(): boolean { return this._allowFiltering;} private _allowFiltering: boolean;

}
